import { useDispatch, useSelector } from 'react-redux';
import { showCompanionRestriction } from '../redux/companionSlice';

export default function useCompanionAccess(forceCompanion = false) {
  const dispatch = useDispatch();
  const hasCompanionSession = useSelector(
    state => Boolean(state.companion.token) && !state.user.access
  );
  const isCompanion = forceCompanion || hasCompanionSession;
  const requireAccount = feature => {
    if (!isCompanion) return false;
    dispatch(showCompanionRestriction(feature));
    return true;
  };
  return { isCompanion, requireAccount };
}
